/**
 *
 * TripInProgressTag
 *
 */

import React, { memo } from 'react';
import styled from 'styled-components';

import PinTripIcon from 'assets/v2/PinTripIcon';
import { COLORS } from 'theme';
import Tag from '..';

const StyledTag = styled(Tag)`
  &.MuiChip-root {
    color: ${COLORS.rustDark};
    background: ${COLORS.rustLight};
    border-color: ${COLORS.rust};
    border-radius: ${({ theme }) => theme.borderRadius.secondary};

    &&& .MuiChip-icon path {
      fill: ${COLORS.rust};
    }
  }
`;

function TripInProgressTag(props) {
  return (
    <StyledTag label="Trip In Progress" icon={<PinTripIcon />} {...props} />
  );
}

export default memo(TripInProgressTag);
